// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3e35T","rootSuccess":"CompleteLink_rootSuccess__2mVCf","rootFailure":"CompleteLink_rootFailure__if6qT","isDisabled":"CompleteLink_isDisabled__33hxL"};